module.exports = __webpack_public_path__ + "img/fondo4.0b84bb29.jpg";